<template>
    <div class="pa-0 flex-grow-1 d-flex flex-column" fluid style="width:100%;">
        <v-layout row align-center :class="`flex-grow-0 d-flex`">
            <v-flex grow class="subheading font-weight-bold info--text px-1">
                <v-btn small block flat @click="toggleNavigationAndFilters">
                    <span v-if="showNavigationAndFilters">Hide Controls</span>
                    <span v-else>Show Controls</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout row class="flex-grow-1 d-flex ma-0">
            <v-flex class="flex-grow-1 d-flex" style="position:relative; height:100%; width:100%;">
                <div class="table-scroll" id="table-scroll-list">
                    <table class="v-datatable v-table theme--light">
                        <thead>
                            <tr style="border:none;" v-if="listSortedItems.length > 0">
                                <th align="left" class="pt-0 pb-0 mt-0 mb-0" colspan="6">
                                    <v-btn  v-if="listSortedItems.length > 0" :loading="exportLoading" color="primary" @click="exportForecast" >
                                        Export
                                    </v-btn>
                                </th>
                            </tr>
                            <tr>
                                <th style="min-width: 200px; padding: 4px;" align="center">
                                    <v-text-field
                                        style="width: 200px;"
                                        label="Location Name"
                                        :value="localFilterLocationName"
                                        @input="handleModifiedFilterLocationNameChanged"
                                        prepend-inner-icon="search"
                                        single-line
                                        hide-details
                                        dense
                                        outline>
                                    </v-text-field>
                                </th>
                                <th style="min-width: 150px;" class="pa-0">Variety</th>
                                <th style="min-width: 100px;" class="pa-0">Next Pick Due</th>
                                <th style="min-width: 100px;" class="pa-0">Last Pick</th>
                                <th style="min-width: 100px;" class="pa-0">Forecast</th>
                                <th style="min-width: 100px;" class="pa-0">Adjusted Forecast</th>
                            </tr>
                        </thead>
                        <tbody v-if="listSortedItems.length == 0">
                            <tr>
                                <td colspan="6"></td>
                            </tr>
                        </tbody>
                        <InfiniteLoadingTableBody v-else :data="listSortedItems" :page-size="12">
                            <template v-slot:rows="{ shownData }">
                                <ForecastingOverviewListRow
                                    v-for="(item, index) in shownData" 
                                    :key="index"
                                    :item="item"
                                    @goToDetail="goToDetail(item)">
                                </ForecastingOverviewListRow>
                            </template>
                            <template v-slot:footerRows>
                                <tr class="fillerRow">
                                    <td v-for="i in 6" :key="i"></td>
                                </tr>
                            </template>
                        </InfiniteLoadingTableBody>
                        <tfoot>
                            <tr>
                                <td class="text-xs-center" colspan="2">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <span>Total Active Locations in selection:</span>
                                            <span class="ml-1 font-weight-bold">{{ listNumberOfLocationsFiltered }}</span>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="caption font-italic">Values shown in kilograms (kg)</span>
                                        </v-flex>
                                    </v-layout>
                                </td>
                                <td class="text-xs-center" colspan="4">
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import ForecastingOverviewListRow from '@/components/forecasting/ForecastingOverviewListRow.vue'
import InfiniteLoadingTableBody from '@/components/generic/InfiniteLoadingTableBody.vue';

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    components: {
        ForecastingOverviewListRow,
        InfiniteLoadingTableBody
    },
    props: {

    },
    data(){
        return {
            modifiedFilterLocationName: null,
            filterLocationNameTimeout: null
        };
    },
    computed: {
        ...mapState("ForecastingStore", [
            "filterLocationName",
            "listSortedItems",
            "listNumberOfLocationsFiltered",
            "exportLoading",
            "showNavigationAndFilters"
        ]),
        localFilterLocationName(){
            if(this.modifiedFilterLocationName != null){
                return this.modifiedFilterLocationName;
            }

            return this.filterLocationName;
        },
        isTabletMode(){
            return this.$vuetify.breakpoint.mdAndDown;
        },
    },
    methods: {
        ...mapMutations("ForecastingStore", [
            "setFilterLocationName",
            "setShowNavigationAndFilters"
        ]),
        ...mapActions("ForecastingStore", [
            "updateData",
            "exportForecast"
        ]),
        toggleNavigationAndFilters(){
            this.setShowNavigationAndFilters(!this.showNavigationAndFilters);
        },
        handleModifiedFilterLocationNameChanged(filterLocationName){
            this.modifiedFilterLocationName = filterLocationName;

            if(this.filterLocationNameTimeout != null){
                clearTimeout(this.filterLocationNameTimeout);
            }

            this.filterLocationNameTimeout = setTimeout(this.handleFilterLocationNameChanged, 200);
        },
        async handleFilterLocationNameChanged(){
            this.filterLocationNameTimeout = null;
            this.setFilterLocationName(this.modifiedFilterLocationName);
            await this.updateData();
            this.modifiedFilterLocationName = null;
        },
        goToDetail(item){
            console.log(this.listSortedItems);
            this.$emit('goToDetail', {
                cropLocationId: item.cropLocationId,
                varietyId: item.varietyId
            });
        }
    },
    created(){
        
    }
}
</script>

<style scoped>
.flex-column {
    flex-direction: column!important;
}

.flex-row {
    flex-direction: row!important;
}

.d-flex {
    display: flex!important;
}

.flex-grow-1 {
    flex-grow: 1!important;
}

.flex-grow-0 {
    flex-grow: 0!important;
}

.table-scroll {
    position: absolute;
    z-index: 1;
    overflow: auto;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    min-height: 100px;
}

.table-scroll table {
    width: 100%;
    height: 100%;
    margin: auto;
}

.table-scroll table tr td, .table-scroll table tr th {
    width: auto;
}

.table-scroll thead tr td, .table-scroll thead tr th {
    position: -webkit-sticky;
    position: sticky;
    background-color: white;
    z-index: 5;
}

.table-scroll thead tr:nth-child(1) td, .table-scroll thead tr:nth-child(1) th {
    top: 0px;
    height: 64px;
}

 .table-scroll thead tr:nth-child(2) td, .table-scroll thead tr:nth-child(2) th {
    top: 64px;
    height: 64px;
} 
 .table-scroll tfoot tr td, .table-scroll tfoot tr th {
    position: -webkit-sticky;
    position: sticky;
    background-color: white;
    z-index: 5;
}

.table-scroll tfoot tr:nth-child(1) td, .table-scroll tfoot tr:nth-child(1) th {
    bottom: 0px;
    height: 64px;
} 

.table-scroll .fillerRow th, .fillerRow td {
    height: auto;
}

table thead th {
    font-size: 16px;;
}
</style>